<template>
  <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3333 17C15.3333 14.5147 17.1242 12.5 19.3333 12.5H32.6667C34.8758 12.5 36.6667 14.5147 36.6667 17V35C36.6667 37.4853 34.8758 39.5 32.6667 39.5H19.3333C17.1242 39.5 15.3333 37.4853 15.3333 35V17Z"
      fill="var(--sf-illustration-primary-background-primary)"
    />
    <path
      d="M17.5 13.6667H25C25.8284 13.6667 26.5 14.4129 26.5 15.3333V17C26.5 17.9205 25.8284 18.6667 25 18.6667H22C21.1716 18.6667 20.5 19.4129 20.5 20.3333V23.6667C20.5 24.5871 21.1716 25.3333 22 25.3333H25C25.8284 25.3333 26.5 26.0795 26.5 27V28.6667C26.5 29.5871 25.8284 30.3333 25 30.3333H17.5M14.5 37H29.5C31.9853 37 34 34.7614 34 32V12C34 9.23858 31.9853 7 29.5 7H14.5C12.0147 7 10 9.23858 10 12V32C10 34.7614 12.0147 37 14.5 37Z"
      stroke="var(--sf-illustration-primary-border)"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
